import { useContext, useState } from "react";
import { roundTo } from "../utils/strings";
import IOAbstract, { EditContext, type IOProps } from "./io-abstract";

//
// Always required
//

export default function IONumber(
  props: {
    precision?: number;
    onChange?: (arg: number) => void;
    validation?: (value: number | undefined) => string;
  } & Omit<IOProps<number>, "onChange">
) {
  const editContext = useContext(EditContext);
  const [currentError, setCurrentError] = useState<string | React.ReactNode>(
    ""
  );

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.valueAsNumber;

    // Custom validation
    const customMessage = props.validation?.(value) ?? "";
    event.target.setCustomValidity(customMessage);

    // validationMessage will hold customMessage
    setCurrentError(event.target.validationMessage);

    props.onChange?.(value);
  };

  return (
    <IOAbstract<number>
      currentError={currentError}
      editContext={editContext}
      inputType="string"
      type="number"
      renderOutput={
        <div>
          {props.precision && props.value
            ? roundTo(props.value, props.precision)
            : "" + props.value}
        </div>
      }
      renderInput={(uuid) => (
        <input
          id={uuid}
          className="form-control"
          defaultValue={props.value}
          name={props.name}
          onChange={onChange}
          required={props.required}
          type="number"
          {...props.htmlProps}
        />
      )}
      {...props}
    />
  );
}
